import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'customDateTime'
})
export class CustomDateTimePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

  transform(value: any): string | null {
    if (value == null || value === '') return null;
    const date = typeof value === 'string' ? new Date(value) : value;
    return formatDate(date, 'dd/MM/yyyy', this.locale);
  }
}
